import type { PlaygroundPlace } from '~/types/Playground.types';

export const PRIMARY_EDIT_BAR_POPOVERS_MAX_WIDTH = 600;
export const PRIMARY_EDIT_BAR_POPOVERS_OFFSET = 25;

/**
 * Formats a list of destinations to a comma-separated string of place names,
 * prioritizing the last added destination and truncating if needed
 */
export function formatDestsToPlaceNames(
  destinations: PlaygroundPlace[],
  lastDestinationId: number | null,
  maxLength: number
): string {
  // get the last added destination by id and move it to the front of the array
  const lastDestinationStillPresent = destinations.find((destination) => destination.id === lastDestinationId);

  const newDestinations = lastDestinationStillPresent
    ? [lastDestinationStillPresent, ...destinations.filter((dest) => dest.id !== lastDestinationId)]
    : destinations;

  const str = newDestinations.map((dest) => dest.n).join(', ');

  if (str.length > maxLength) {
    return `${str.slice(0, maxLength)}...`;
  }

  return str;
}
